module.exports = __webpack_public_path__ + "static/2.0_landingpage_image_v5-42c85356209c28738c3046f6eead615e.jpg";